<template>
  <div class="add-social-network-link-form">
    <v-form ref="form">
      <text-field
        :rules="[rules.linkedin]"
        type="text"
        v-model="linkedinLink"
        class="linkedin-link"
        :label="$t('registration.sp.company.certification.linkedin.label')"
        :placeholder="$t('registration.sp.freelancer.company.certification.linkedin.placeholder')"
      />
    </v-form>
  </div>
</template>

<script>
import { rules } from '@/utils/validationUtils';
import TextField from '@/components/common/TextField.vue';

export default {
  name: 'CompanySPAddLinkedinLink',
  components: {
    TextField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valid: this.value.valid,
      linkedinLink: this.value.linkedinLink || '',
    };
  },
  computed: {
    rules() {
      return {
        ...rules,
      };
    },
    linksData() {
      return {
        linkedinLink: this.linkedinLink,
      };
    },
  },
  methods: {
    async formChanged() {
      this.valid = this.rules.linkedin(this.linkedinLink);
      this.$emit('onLinkedInLinkChanged', { ...this.linksData, valid: this.valid });
    },
  },
  watch: {
    linkedinLink() {
      this.formChanged();
    },
  },
};
</script>

<style>
.add-social-network-link-form {
  width: 444px;
  margin-bottom: 32px;
}
.linkedin-link {
  margin-top: 18px;
}
</style>
